<section class="md:h-screen py-36 flex items-center bg-neutral-900 bg-no-repeat bg-center">
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black"></div>
  <div class="container">
    <div class="flex justify-center">
      <div class="max-w-[400px] w-full m-auto p-6 bg-white dark:bg-neutral-900 shadow-md dark:shadow-neutral-900 rounded-md">
        <a [routerLink]="'/'">
          <img [src]="'assets/images/logo-dark.png'" class="mx-auto h-7 block dark:hidden" alt="">
          <img [src]="'assets/images/logo-light.png'" class="mx-auto h-7 dark:block hidden" alt="">
        </a>
        <h5 class="my-6 text-xl font-semibold">{{ 'PASSWORD.RESET_PASSWORD_TITLE' | translate }}</h5>

        <!-- Error message display -->
        @if (errorMessage) {
          <div class="my-4 p-3 bg-red-100 text-red-700 rounded-md">
            {{ errorMessage }}
          </div>
        }

        @if (!successMessage) {
          <div class="my-4 p-3 bg-green-100 text-green-700 rounded-md">
            {{ 'PASSWORD.RESET_SENT_ALERT' | translate }}
          </div>
        }

        <!-- Success message display -->
        @if (successMessage) {
          <div class="my-4 p-3 bg-green-100 text-green-700 rounded-md">
            {{ successMessage | translate }}
          </div>
        }

        <!-- Reset Password Form -->
        @if (!resetComplete) {
          <div>
            <div class="grid grid-cols-1">
              <p class="mb-6">{{ 'PASSWORD.RESET_PASSWORD_DESC' | translate }}</p>
              <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="text-start">
                <div class="grid grid-cols-1">
                  <div class="mb-4">
                    <label class="font-semibold" for="email">{{ 'PASSWORD.EMAIL' | translate }}:</label>
                    <input id="email" type="email" formControlName="email"
                      class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-neutral-600 dark:border-neutral-900 dark:focus:border-neutral-600 focus:ring-0 mt-3"
                      [ngClass]="{'bg-gray-100 dark:bg-slate-800': resetPasswordForm.get('email')?.disabled}"
                      placeholder="name@example.com">
                    @if (resetPasswordForm.get('email')?.disabled) {
                      <div class="text-sm mt-1">
                        <i class="fas fa-lock mr-1"></i> {{ 'PASSWORD.EMAIL_LOCKED' | translate }}
                      </div>
                    }
                    @if (resetPasswordForm.get('email')?.invalid && resetPasswordForm.get('email')?.touched) {
                      <div class="text-red-500 text-sm mt-1">
                        {{ 'PASSWORD.INVALID_EMAIL' | translate }}
                      </div>
                    }
                  </div>
                  <div class="mb-4">
                    <label class="font-semibold" for="code">{{ 'PASSWORD.RESET_CODE' | translate }}:</label>
                    <input id="code" type="text" formControlName="code" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-neutral-600 dark:border-neutral-900 dark:focus:border-neutral-600 focus:ring-0 mt-3" placeholder="12345678">
                    @if (resetPasswordForm.get('code')?.invalid && resetPasswordForm.get('code')?.touched) {
                      <div class="text-red-500 text-sm mt-1">
                        {{ 'PASSWORD.INVALID_CODE' | translate }}
                      </div>
                    }
                  </div>
                  <div class="mb-4">
                    <label class="font-semibold" for="password">{{ 'PASSWORD.NEW_PASSWORD' | translate }}:</label>
                    <input id="password" type="password" formControlName="password" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-neutral-600 dark:border-neutral-900 dark:focus:border-neutral-600 focus:ring-0 mt-3" placeholder="********">
                    @if (resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched) {
                      <div class="text-red-500 text-sm mt-1">
                        {{ 'PASSWORD.INVALID_PASSWORD' | translate }}
                      </div>
                    }
                  </div>
                  <div class="mb-4">
                    <label class="font-semibold" for="confirmPassword">{{ 'PASSWORD.CONFIRM_PASSWORD' | translate }}:</label>
                    <input id="confirmPassword" type="password" formControlName="confirmPassword" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-neutral-600 dark:border-neutral-900 dark:focus:border-neutral-600 focus:ring-0 mt-3" placeholder="********">
                    @if (resetPasswordForm.get('confirmPassword')?.errors?.['required'] && resetPasswordForm.get('confirmPassword')?.touched) {
                      <div class="text-red-500 text-sm mt-1">
                        {{ 'PASSWORD.CONFIRM_PASSWORD_REQUIRED' | translate }}
                      </div>
                    }
                    @if (resetPasswordForm.get('confirmPassword')?.errors?.['passwordMismatch'] && resetPasswordForm.get('confirmPassword')?.touched) {
                      <div class="text-red-500 text-sm mt-1">
                        {{ 'PASSWORD.PASSWORDS_DONT_MATCH' | translate }}
                      </div>
                    }
                  </div>
                  <div class="mb-4">
                    <app-button [disabled]="resetPasswordForm.invalid" [loading]="isLoading" color="primary" rounded="full" [fullWidth]="true" [type]="'submit'">
                      {{ 'PASSWORD.RESET_PASSWORD_BTN' | translate }}
                    </app-button>
                  </div>
                  <div class="text-center">
                    <span class="me-2">{{ 'PASSWORD.REMEMBER_PASSWORD' | translate }} </span><a [routerLink]="'/login'" class="font-bold">{{ 'PASSWORD.SIGN_IN' | translate }}</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        }

        <!-- Success View -->
        @if (resetComplete) {
          <div class="grid grid-cols-1">
            <div class="text-center mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 text-green-500 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              <p class="mt-4">{{ 'PASSWORD.RESET_SUCCESS_DESC' | translate }}</p>
            </div>
            <div class="mb-4">
              <app-button type="button" (click)="goToLogin()" color="primary" rounded="full" [fullWidth]="true">
                {{ 'PASSWORD.GO_TO_LOGIN' | translate }}
              </app-button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
